export const ExternalLinkEnum = {
  // paypalDeepLink = `https://www.paypal.com`,
  paypalDeepLink: `paypal://`,
  paypalDeepLinkAndroid: `paypal://`,
  paypalWebUrl: `https://www.paypal.com`
}
